import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ isOpen, planName, onClose, onConfirm, isSubmitting }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-lg shadow-xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
            <Icon name="CheckCircle" size={24} className="text-success" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Confirm Plan Creation
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              Are you sure you want to create the <span className="font-semibold text-foreground">{planName}</span> plan? This will make it available for subscription.
            </p>
            <div className="flex gap-3">
              <Button
                variant="outline"
                onClick={onClose}
                fullWidth
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                variant="default"
                onClick={onConfirm}
                iconName="Save"
                iconPosition="left"
                fullWidth
                loading={isSubmitting}
              >
                Confirm & Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;